export default __webpack_public_path__ + "static/media/FUE.d5af6942.svg";